var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal-container" }, [
          _c(
            "div",
            { staticClass: "modal-header" },
            [
              _vm._t("header", function () {
                return [_vm._v("\n            slot header\n          ")]
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm._t("body", function () {
                return [_vm._v("\n            slot body\n          ")]
              }),
            ],
            2
          ),
          _c("div", { staticClass: "modal-footer" }, [
            _c("div", { staticClass: "lgrid-right-middle" }, [
              _c(
                "button",
                {
                  staticClass: "button modal-default-button",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("cancel")
                    },
                  },
                },
                [
                  _vm._t("cancel", function () {
                    return [_vm._v("\n                Annuler\n              ")]
                  }),
                ],
                2
              ),
              _c(
                "button",
                {
                  staticClass: "button colored modal-default-button",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("apply")
                    },
                  },
                },
                [
                  _vm._t("apply", function () {
                    return [_vm._v("\n                Valider\n              ")]
                  }),
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }